import {calculateHeight} from './calculateFunctions/height'
import {calculateWidth} from './calculateFunctions/width'
import {calculateX} from './calculateFunctions/x'
import {calculateY} from './calculateFunctions/y'
import type {CalculateAPI, CalculateFunction, CalculateParams} from './types'
import type {CompRef} from '@wix/document-services-types'
import {getLayout} from './utils'
import {calculateColumns} from './calculateFunctions/columns'
import {calculateRows} from './calculateFunctions/rows'

const forParent =
    (calculateFunction: CalculateFunction): CalculateFunction =>
    (calculateParams: CalculateParams) => {
        const {extensionAPI, pointers, compRef} = calculateParams
        const parentRef = pointers.structure.getParent(compRef)! as CompRef
        const parentLayout = getLayout(extensionAPI, parentRef)
        calculateFunction({...calculateParams, compRef: parentRef, layoutData: parentLayout})
    }

export const createCalculateAPI = (): CalculateAPI => {
    return {
        width: calculateWidth,
        height: calculateHeight,
        x: calculateX,
        y: calculateY,
        columns: calculateColumns,
        rows: calculateRows,
        parent: {
            width: forParent(calculateWidth),
            height: forParent(calculateHeight),
            columns: forParent(calculateColumns),
            rows: forParent(calculateRows)
        }
    }
}
